import { useMemo } from 'react'
import _values from 'lodash/values'

import { type EmissionsData } from 'types/data'

export const getEmissionsDataPointCount = (data: EmissionsData): number =>
  useMemo(() => _values(data).length, [data])
